<template>
  <div class="about">
    <h1 class="text-left ml-15 mt-2">{{gifts.name}}</h1>
    <!-- <slot-panel ref="slot-machine" /> -->
    <slot-machine-dp ref="slot-machine" :typeSlot="this.$route.name"
    :items="gifts"
    />
    <!-- <v-btn @click="handleClick">CEK ITEM</v-btn> -->
  </div>
</template>

<script>
import SlotMachineDp from '../../components/SlotMachine/SlotMachineDp.vue'

import { mapState } from 'vuex'

export default {
  name: 'SlotDoorprize',
  data() {
    return {
      items: {}
    }
  },
  components: {
    SlotMachineDp
  },
  computed: {
    ...mapState({
      gifts: state => state.slotDoorprize.gifts,
      person: state => state.slotMachine.person
    })
  },
  created() {
    // this.$store.dispatch('getDoorprize', this.$route.params.id)
    this.$store.dispatch('getPersonDoorprize')
  },
  mounted() {
    if (this.$route.params.items) {
      this.$store.commit('SET_DOORPRIZE_DATA', this.$route.params.items) //hanya set dari params, tidak dari api
    } else {
      this.items = this.person
    }
  },
  methods: {
    handleClick() {
      // if (this.gifts) console.log('data ada');
      // console.log(this.$store.getters.getDigitPerson, this.gifts, ' ada')
    }
  }
}
</script>